export default "__VITE_ASSET__eGXo07vb__"